import { Button, type ButtonProps, type ComponentWithAs, type IconProps } from "@chakra-ui/react"
import { FormattedMessage, useIntl } from "react-intl"

import { isNotBlank, isNotNullNorUndefined } from "@/utils/ts-utils"

type Props = {
  icon?: ComponentWithAs<"svg", IconProps>
  iconSize?: string | number
  textTranslationId?: string
} & ButtonProps

export const LinkButtonWithIcon: React.FC<Props> = ({
  icon: Icon,
  iconSize,
  textTranslationId,
  ...props
}) => {
  const intl = useIntl()

  return (
    <Button
      variant={props.variant ?? "link"}
      display={props.display ?? "flex"}
      gap={props.gap ?? 1}
      alignItems={props.alignItems ?? "center"}
      color={props.color ?? "text"}
      fontWeight={props.fontWeight ?? "600"}
      textDecoration={props.textDecoration ?? "none"}
      aria-label={
        props.title ??
        (isNotBlank(textTranslationId) ? intl.formatMessage({ id: textTranslationId }) : undefined)
      }
      {...props}
    >
      {isNotBlank(textTranslationId) && <FormattedMessage id={textTranslationId} />}
      {isNotBlank(props.title) && props.title}
      {isNotNullNorUndefined(Icon) && <Icon boxSize={iconSize ?? 4} />}
    </Button>
  )
}
